export default {
  computed: {
    // $test () {
    //   return this.$store.state.main.test
    // }
  }
}
